(function (Drupal) {

  'use strict';

  Drupal.behaviors.eventBanner = {
    attach: function (context, settings) {
      once('eventBanner', '#page-wrapper', context).forEach((pageWrapper) => {
        const banner = pageWrapper.querySelector('#event-banner-element');

        if (banner === null || banner.style.display === 'none') {
          return;
        }

        const mobileWidth = 991;
        const headerMarginTop = 80;
        const cookieExpire = 7;
        const header = pageWrapper.querySelector('#header');
        let lastScrollTop = 0;

        function handleScroll() {
          let scrollPosition = window.scrollY || context.documentElement.scrollTop;
          const shouldSetBannerAsSticky = scrollPosition < lastScrollTop || (window.scrollY <= 1 && window.innerWidth <= mobileWidth)
          const shouldSetMenuAsSticky = window.scrollY === 0 && window.innerWidth > mobileWidth;

          if (scrollPosition > banner.offsetHeight) {
            banner.classList.add('stick-initialized');
          } else {
            banner.classList.remove('stick-initialized');
          }

          if (
            shouldSetBannerAsSticky
          ) {
            banner.classList.add('stick-direction-top');
            banner.classList.remove('stick-menu-hidden');
          }

          if (shouldSetMenuAsSticky || !shouldSetBannerAsSticky) {
            banner.classList.remove('stick-direction-top');
            banner.classList.add('stick-menu-hidden');
          }

          lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
        }

        function positionBanner() {
          header.style.marginTop = 0;
          banner.style.top = '';

          if (window.innerWidth > mobileWidth) {
            header.style.marginTop = headerMarginTop + 'px';
          } else if (window.scrollY === 0) {
            const bannerPosition = header.offsetTop + header.offsetHeight;
            banner.style.top = bannerPosition + 'px';
          } else if (window.innerWidth <= mobileWidth) {
            context.querySelector('button.navbar-toggler').style.zIndex = '8';
          }
        }

        function handleBannerButtonClick(bannerBtn) {
          if (!bannerBtn || bannerBtn.dataset.close !== '1') {
            return;
          }

          bannerBtn.addEventListener('click', function () {
            banner.classList.add('banner-closing');
            if (window.innerWidth > mobileWidth) {
              header.style.marginTop = '0';
            }
            setTimeout(function () {
              banner.style.display = 'none';
            }, 500);

            Cookies.set('banner-hide', '1', { expires: cookieExpire });
          });
        }

        positionBanner();
        window.addEventListener('scroll', function () {
          handleScroll();
        });
        window.addEventListener('resize', function () {
          positionBanner();
          handleScroll();
        });
        handleBannerButtonClick(context.querySelector('#banner-btn-1'));
        handleBannerButtonClick(context.querySelector('#banner-btn-2'));
      });
    }
  }
})(Drupal);
